import { useTranslation } from 'react-i18next';
import './style.css';

const QuotationSummary = ({ admissionDetails }) => {
    const { t } = useTranslation();

    const packages = admissionDetails?.requestData?.packages || [];
    const addOns = admissionDetails?.requestData?.addOns || [];

    return (
        <div className="quotation-summary-section">
            
            <h2 className="quotation-summary-title">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {t('quotation-summary')}
            </h2>

            <div className="quotation-summary-cards">

                <div className="quotation-summary-card">
                    <div className="quotation-summary-label">{t('expected-length-of-stay')}</div>
                    <div className="quotation-summary-value">{admissionDetails?.requestData?.expectedLengthOfStay || '2 - 3'} {t('days')}</div>
                </div>
            </div>


            <div className="quotation-summary-cards-container">
            <div className="quotation-summary-card package-card">
                <div className="quotation-summary-label">{t('included-in-your-package')}</div>

                <div className="quotation-summary-package-list">
                    {packages?.map((item, index) => (
                        <div key={index} className="quotation-summary-package-item">
                            <span className="quotation-summary-package-name">{item?.toUpperCase()}</span>
                            <span className="quotation-summary-package-name quotation-summary-package-price">$ {"0.00"}</span>
                        </div>
                    ))}
                </div>
            </div>
            {/* Included in Your Package */}
            <div className="quotation-summary-card add-ons-card">
                <div className="quotation-summary-label">{t('add-ons-extras')}</div>

                <div className="quotation-summary-package-list">
                    {addOns?.map((item, index) => (
                        <div key={index} className="quotation-summary-package-item">
                            <span className="quotation-summary-package-name">{item?.name?.toUpperCase()}</span>
                            <span className="quotation-summary-package-name quotation-summary-package-price">$ {item?.price?.toFixed(2)}</span>
                        </div>
                    ))}
                </div>
            </div>
            </div>

            {/* Total */}
            <div className="quotation-summary-total-section">
                <div className="quotation-summary-total-row">
                    <span className="quotation-summary-total-label">{t('estimated-total-package-cost')}</span>
                    <span className="quotation-summary-total-value">${admissionDetails?.requestData?.totalPrice?.toFixed(2) || '3,450.00'}</span>
                </div>
            </div>
        </div>
    );
};

export default QuotationSummary;
